module.exports = __webpack_public_path__ + "static/img/empty.22957b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/empty.png
// module id = HeD3
// module chunks = 6